import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'
import Image from '#app/components/content/Image'

export default function TweetTemplate({ tweet }: { tweet: any }) {
	const tooltipCopyTweetUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyComment = useRef<TooltipRefProps>(null)
	const tooltipCopyIpfsUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyPng = useRef<TooltipRefProps>(null)
	const tooltipCopyUser = useRef<TooltipRefProps>(null)
	const tooltipCopyContent = useRef<TooltipRefProps>(null)
	const tooltipCopySignature = useRef<TooltipRefProps>(null)

	const tweetIPFSCID = tweet.properties.ipfsCID

	const extractIPFSCID = (ipfsURL: string) => {
		const ipfsSegments = ipfsURL.split('/')
		return ipfsSegments[ipfsSegments.length - 1]
	}

	return (
		<>
			<div
				id="tweetUrl"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(tweet.properties.url)
					tooltipCopyTweetUrl.current?.open({
						anchorSelect: '#tweetUrl',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyTweetUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyTweetUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Social Post URL:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{tweet.properties.url}
				</TypographyParagraph>
			</div>
			<div
				id="comment"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(tweet.properties.description)
					tooltipCopyComment.current?.open({
						anchorSelect: '#comment',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyComment.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyComment} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Comment:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
				>
					{tweet.properties.description}
				</TypographyParagraph>
			</div>
			<div
				id="ipfsUrl"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(tweetIPFSCID)
					tooltipCopyIpfsUrl.current?.open({
						anchorSelect: '#ipfsUrl',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyIpfsUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyIpfsUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					IPFS CID:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{extractIPFSCID(tweetIPFSCID)}
				</TypographyParagraph>
			</div>
			<div
				id="png"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(tweetIPFSCID)
					tooltipCopyPng.current?.open({
						anchorSelect: '#png',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyPng.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyPng} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					PNG:
				</TypographyParagraph>
				<Image
					className="h-auto w-1/3"
					imageUrl={tweetIPFSCID}
					imageAlt={tweetIPFSCID}
					containerClassName="flex items-center justify-center w-full"
				/>
			</div>
			{tweet.properties.user && (
				<div
					id="user"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(tweet.properties.user)
						tooltipCopyUser.current?.open({
							anchorSelect: '#user',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyUser.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyUser} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						User:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.properties.user}
					</TypographyParagraph>
				</div>
			)}
			{tweet.properties.content && (
				<div
					id="content"
					className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
					onClick={() => {
						navigator.clipboard.writeText(tweet.properties.content)
						tooltipCopyContent.current?.open({
							anchorSelect: '#content',
							content: 'Copied!',
						})
						setTimeout(() => {
							tooltipCopyContent.current?.close()
						}, 2000)
					}}
				>
					<Tooltip imperativeModeOnly ref={tooltipCopyContent} />
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Content:
					</TypographyParagraph>
					<TypographyParagraph
						size="medium"
						additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.properties.content}
					</TypographyParagraph>
				</div>
			)}
			<div
				id="signature"
				className="flex flex-row p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(tweet.signature)
					tooltipCopySignature.current?.open({
						anchorSelect: '#signature',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopySignature.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopySignature} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Signature:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{tweet.signature}
				</TypographyParagraph>
			</div>
		</>
	)
}
